import type { MultibuyPriceLevel } from '~/api/Catalog';

export const capByOrderLimit = (
  limit: number,
  ...caps: Array<number | null | undefined>
): number =>
  Math.min(
    limit,
    ...caps.filter((cap): cap is number => typeof cap === 'number' && cap > 0),
  );

export const dropUnreachableMultibuyLevels = (
  levels: MultibuyPriceLevel[],
  maxQuantityPerOrder: number,
): MultibuyPriceLevel[] =>
  maxQuantityPerOrder > 0
    ? levels.filter((level) => level.quantity <= maxQuantityPerOrder)
    : levels;
